import $ from 'jquery';

const autoscroll = function () {
  const blocks = $('[autoscroll-contents]');
  var speed = 20000, width = $(window).width();
  if(width > 767) speed = 30000;
  blocks.removeClass('d-flex');
  blocks.marquee({
        duration: speed,
        gap: 0,
        delayBeforeStart: 0,
        direction: 'left',
        duplicated: true,
        startPosition: 2,
        startVisible:true
    });

}

export default autoscroll;